<template>
	<div class="tw-flex tw-rounded-lg tw-animate-pulse tw-bg-primary-200 tw-fill-primary-400 tw-items-center tw-justify-center tw-h-full tw-w-full">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			height="2em"
			viewBox="0 0 512 512">
			<path
				d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z" />
		</svg>
	</div>
</template>